import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { useTranslation } from "react-i18next";

const EdenAutoPromoSection = () => {
  const { t, i18n } = useTranslation();

  return (
    <Box
      sx={{
        backgroundColor: '#0a0a0a',
        py: { xs: 4, md: 8 },
        borderTop: '1px solid rgba(212, 175, 55, 0.1)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.1)'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 3, md: 6 }} alignItems="center">
          {/* Photo Left */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: '16px',
                overflow: 'hidden',
                height: { xs: '300px', md: '400px' },
                boxShadow: '0 8px 32px rgba(212, 175, 55, 0.2)',
                '&:hover': {
                  boxShadow: '0 12px 48px rgba(212, 175, 55, 0.3)',
                  transition: 'box-shadow 0.3s ease'
                }
              }}
            >
              <Box
                component="img"
                src="https://www.lamontagne.fr/static/bloc/pagesStatiques/publi_redac/images/22-05-edenauto-toyota-logo-1.jpg"
                alt="Eden Auto Montauban"
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'block',
                  objectFit: 'cover',
                  objectPosition: 'center'
                }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  top: { xs: 12, md: 16 },
                  right: { xs: 12, md: 16 },
                  backgroundColor: '#D4AF37',
                  color: '#000',
                  px: { xs: 1.5, md: 2.5 },
                  py: { xs: 0.75, md: 1 },
                  borderRadius: '8px',
                  fontSize: { xs: '0.75rem', md: '1rem' },
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                }}
              >
                10% de remise
              </Box>
            </Box>
          </Grid>

          {/* Text Right */}
          <Grid item xs={12} md={6}>
            <Box>
              <Typography
                variant="h3"
                sx={{
                  color: '#D4AF37',
                  fontWeight: 700,
                  fontSize: { xs: '1.5rem', md: '2.5rem' },
                  mb: { xs: 1.5, md: 2 },
                  lineHeight: 1.2
                }}
              >
                Eden Auto Montauban
              </Typography>
              
              <Typography
                variant="h5"
                sx={{
                  color: '#fff',
                  fontWeight: 500,
                  fontSize: { xs: '1rem', md: '1.5rem' },
                  mb: { xs: 2, md: 3 },
                  lineHeight: 1.4
                }}
              >
                Tarifs préférentiels sur les modèles Toyota
              </Typography>

              <Box
                sx={{
                  backgroundColor: 'rgba(212, 175, 55, 0.1)',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                  borderRadius: '12px',
                  padding: { xs: 2, md: 4 },
                  mb: { xs: 2, md: 3 }
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    color: '#fff',
                    fontSize: { xs: '1rem', md: '1.125rem' },
                    lineHeight: 1.8,
                    mb: 2
                  }}
                >
                  Bénéficiez de <strong style={{ color: '#D4AF37' }}>10% de remise</strong> chez notre partenaire 
                  <strong style={{ color: '#D4AF37' }}> Eden Auto Montauban</strong> sur les modèles suivants :
                </Typography>

                <Box
                  component="ul"
                  sx={{
                    listStyle: 'none',
                    padding: 0,
                    margin: 0,
                    display: 'grid',
                    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                    gap: 1.5
                  }}
                >
                  {['AYGO X', 'YARIS CROSS', 'COROLLA TOURING', 'C-HR'].map((model, index) => (
                    <Box
                      component="li"
                      key={index}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        color: '#D4AF37',
                        fontSize: { xs: '0.95rem', md: '1.05rem' },
                        fontWeight: 600
                      }}
                    >
                      <Box
                        component="span"
                        sx={{
                          width: 8,
                          height: 8,
                          backgroundColor: '#D4AF37',
                          borderRadius: '50%',
                          mr: 1.5,
                          flexShrink: 0
                        }}
                      />
                      {model}
                    </Box>
                  ))}
                </Box>
              </Box>

              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 3,
                  flexWrap: 'wrap'
                }}
              >
                <Box
                  component="img"
                  src="https://www.guide-auto.com/wp-content/uploads/2022/12/toyota-logo.png"
                  alt="Toyota"
                  sx={{
                    height: { xs: '40px', md: '50px' },
                    width: 'auto'
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: '#999',
                    fontSize: { xs: '0.875rem', md: '1rem' }
                  }}
                >
                  Concessionnaire Toyota Business
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default EdenAutoPromoSection;
